import ProductViewModel from "./ProductViewModel";
import IParentProductModel from "../IParentProductModel";
import ProductQuantityViewModel from "./ProductQuantityViewModel";

export default class ParentProductViewModel {
    public parent: ProductViewModel = new ProductViewModel();
    public children: ProductViewModel[] = [];
    public selectedVm: ProductViewModel = new ProductViewModel();
    public pkgItemFinalized = false;
    public parentInitialized = false;
    public isNotFirstProductGroupPageLoad = false;
    public pkgFinalizedGroupProductMembers: ProductViewModel[] = [];

    public async getParent(
        productId: number,
        categoryId: number,
        shouldGetProductGroupDetails?: boolean
    ): Promise<void> {
        await this.parent.get(productId, categoryId, shouldGetProductGroupDetails);
        this.selectedVm = this.parent;
        this.parentInitialized = true;
        if (!this.parent.productGroupDetails) this.isNotFirstProductGroupPageLoad = true;
    }

    public toModel() {
        const childArray: ProductViewModel[] = [];
        this.children.forEach((child) => {
            childArray.push(child.clone());
        });

        const finalizedGroupMemberArray: ProductViewModel[] = [];
        this.pkgFinalizedGroupProductMembers.forEach((member) => {
            finalizedGroupMemberArray.push(member.clone());
        });

        const result: IParentProductModel = {
            parent: this.parent.clone(),
            children: childArray,
            pkgFinalizedGroupProductMembers: finalizedGroupMemberArray,
            selectedVm: this.selectedVm.clone(),
            pkgItemFinalized: this.pkgItemFinalized,
            parentInitialized: this.parentInitialized,
            isNotFirstProductGroupPageLoad: this.isNotFirstProductGroupPageLoad,
        };
        return result;
    }

    public fromModel(model: IParentProductModel) {
        this.parent = model.parent;
        this.children = model.children;
        this.selectedVm = model.selectedVm;
        this.pkgItemFinalized = model.pkgItemFinalized;
        this.parentInitialized = model.parentInitialized;
        this.isNotFirstProductGroupPageLoad = model.isNotFirstProductGroupPageLoad;
        this.pkgFinalizedGroupProductMembers = model.pkgFinalizedGroupProductMembers;
    }

    public clone() {
        const modelCopy = this.toModel();
        const vmCopy = new ParentProductViewModel();
        vmCopy.fromModel(modelCopy);
        return vmCopy;
    }

    public async getChild(productId: number, categoryId: number): Promise<ProductViewModel> {
        let target = new ProductViewModel();

        //make sure we didn't reclick the parent
        if (this.parent.productId == productId) {
            this.selectedVm = this.parent;
            if (this.selectedVm.productGroupDetails) {
                this.isNotFirstProductGroupPageLoad = true;
                this.selectedVm.groupProductParentSelected(productId);
            }
            return this.parent;
        }

        //check to see if we already have children data
        this.children.forEach((child) => {
            if (child.productId == productId) {
                target = child;
            }
        });
        if (target.productId) {
            this.selectedVm = target;
            if (this.selectedVm.productGroupDetails) this.selectedVm.productGroupDetails.setProductSelected(productId);
            return target;
        }
        //if we don't already have the children data request it
        const childModel = new ProductViewModel();
        const shouldGetProductGroupDetails = false;
        await childModel.get(productId, categoryId, shouldGetProductGroupDetails);

        let parent = this.parent;

        // if this is a childProcessProduct, search in the other 'children' for its parent in case that this is a group product member
        if (
            childModel.product &&
            childModel.product.processProductParentId &&
            this.parent.productId != childModel.product.processProductParentId
        ) {
            const processProductParentId = childModel.product.processProductParentId;
            this.children.forEach((item) => {
                if (item.productId == processProductParentId) {
                    parent = item;
                }
            });
        }

        // if the childModel is a productProcessChild, put in the parent unique fields into the child
        if (childModel.product && childModel.product.processProductParentId && parent && parent.product) {
            childModel.colorSize.designsObject = parent.colorSize.designsObject;
            childModel.product.designCount = parent.product.designCount;
            childModel.product.allPricesSame = parent.product.allPricesSame;
            childModel.product.startingPriceDisplay = parent.product.startingPriceDisplay;
            childModel.categoryId = parent.categoryId;
            childModel.product.maxQuantity = parent.product.maxQuantity;
        }

        // if this is a member of a group product, set the group details in the childModel
        if (this.parent.productGroupDetails) {
            this.isNotFirstProductGroupPageLoad = true;
            childModel.productGroupDetails = this.parent.productGroupDetails;
            childModel.productGroupDetails.addRelatedProcessProductIds(
                productId,
                childModel.colorSize.designsObject.designs
            );
            childModel.productGroupDetails.setProductSelected(productId);
        }

        this.children.push(childModel);
        this.selectedVm = childModel;
        return childModel;
    }
}
